<mat-dialog-actions>
    <div
        class="flex w-full items-center gap-2"
        [class.justify-center]="presentation() === 'confirmation'"
    >
        @if (presentation() === 'standard') {
            <div class="flex min-w-0 items-center gap-2">
                <ng-content select="[dialogFooterStart]" />
            </div>
        }

        <div
            class="flex min-w-0 items-center gap-2"
            [class.ml-auto]="presentation() === 'standard'"
            [class.flex-wrap]="presentation() === 'confirmation'"
            [class.justify-center]="presentation() === 'confirmation'"
        >
            @if (resolvedCancelButton(); as cancelButton) {
                <button
                    qpxButton
                    matButton="outlined"
                    [disabled]="isProcessing()"
                    (click)="onDismiss()"
                    [attr.cdkFocusInitial]="
                        presentation() === 'confirmation' ? '' : null
                    "
                >
                    @if (cancelButton.icon) {
                        <ng-icon
                            qpx
                            size="sm"
                            [name]="cancelButton.icon"
                            matButtonIcon
                        />
                    }
                    <span>{{ cancelButton.label }}</span>
                </button>
            }

            @if (resolvedConfirmButton(); as confirmButton) {
                <button
                    qpxButton
                    matButton="filled"
                    [context]="confirmButton.theme"
                    [disabled]="isProcessing() || confirmDisabled()"
                    (click)="onConfirm()"
                    [attr.cdkFocusInitial]="
                        presentation() === 'confirmation' &&
                        !resolvedCancelButton()
                            ? ''
                            : null
                    "
                >
                    @if (isProcessing() && processingAppearance() !== 'body') {
                        <qpx-loading-icon matButtonIcon />
                    } @else if (confirmButton.icon) {
                        <ng-icon
                            qpx
                            size="sm"
                            [name]="confirmButton.icon"
                            matButtonIcon
                        />
                    }
                    <span>{{ confirmButton.label }}</span>
                </button>
            }
        </div>
    </div>
</mat-dialog-actions>
